import { useState, useEffect } from "react";
import { toast } from "sonner";
import { get, put, inputCls, btnDark, Card, SectionTitle, PRODUCT_NAMES } from "./shared";
import { PRODUCTS } from "../../data/products";

const StockRow = ({ pid, value, threshold, sold, waiting, onSaved }) => {
  const [qty, setQty] = useState(value);
  const p = PRODUCTS.find((x) => x.id === pid);
  const save = async () => {
    try {
      const r = await put(`/stock/${pid}`, { stock: Number(qty) });
      toast.success(`Stock ${PRODUCT_NAMES[pid] || pid} : ${qty}${r.notified ? ` · ${r.notified} client(s) prévenu(s) par email` : ""}`);
      onSaved();
    } catch { toast.error("Erreur stock"); }
  };
  const low = value <= threshold;
  return (
    <Card className="flex items-center gap-4 p-4" data-testid={`admin-stock-${pid}`}>
      {p && <img src={p.image} alt="" className="w-12 h-14 object-cover rounded-lg" style={{ backgroundColor: p.bgTint }} />}
      <div className="flex-1 min-w-0">
        <p className="font-serif text-lg text-stone-900 truncate">{PRODUCT_NAMES[pid] || pid}</p>
        <p className={`text-[10px] font-mono uppercase tracking-wide ${value === 0 ? "text-[#C85A32]" : low ? "text-amber-600" : "text-stone-400"}`}>
          {value === 0 ? "Rupture de stock" : low ? `Stock bas · ${value}` : `${value} en stock`} · {sold || 0} vendu(s){waiting ? ` · ${waiting} en attente d'alerte` : ""}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <input data-testid={`admin-stock-input-${pid}`} type="number" min="0" value={qty} onChange={(e) => setQty(e.target.value)} className={`${inputCls} w-24`} />
        <button data-testid={`admin-stock-save-${pid}`} onClick={save} className={btnDark}>OK</button>
      </div>
    </Card>
  );
};

export const Stock = ({ stats, settings, onSaved, onSettings }) => {
  const [thr, setThr] = useState(settings?.low_stock_threshold ?? 10);
  const [alerts, setAlerts] = useState({});
  useEffect(() => { get("/stock-alerts").then(setAlerts).catch(() => {}); }, [stats]);
  const saveThr = async () => {
    try {
      const s = await put("/settings", { low_stock_threshold: Number(thr) });
      onSettings(s); toast.success(`Seuil d'alerte : ${s.low_stock_threshold}`); onSaved();
    } catch { toast.error("Erreur"); }
  };
  if (!stats) return null;
  return (
    <div className="space-y-6" data-testid="admin-stock">
      <Card className="p-5 flex flex-wrap items-center justify-between gap-4">
        <div>
          <SectionTitle>Seuil d'alerte stock bas</SectionTitle>
          <p className="text-sm text-stone-600 -mt-2">Les produits à ce niveau ou en dessous apparaissent dans les alertes de l'aperçu.</p>
        </div>
        <div className="flex items-center gap-2">
          <input data-testid="stock-threshold-input" type="number" min="0" value={thr} onChange={(e) => setThr(e.target.value)} className={`${inputCls} w-24`} />
          <button data-testid="stock-threshold-save" onClick={saveThr} className={btnDark}>Enregistrer</button>
        </div>
      </Card>
      <div className="grid md:grid-cols-2 gap-4">
        {Object.entries(stats.stock).map(([pid, qty]) => (
          <StockRow key={pid} pid={pid} value={qty} threshold={stats.low_stock_threshold} sold={stats.product_sales[pid]} waiting={alerts[pid]} onSaved={onSaved} />
        ))}
      </div>
    </div>
  );
};
